export default "__VITE_ASSET__BPV_HmIA__"